module.exports = __webpack_public_path__ + "static/img/img_logo.993b0b12.png";